import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SimpleReactValidator from "simple-react-validator";
import SearchSelect from "views/lib/components/SearchSelect";
import {
  triggerAdd,
  triggerUpdate,
  triggerGetActions,
  triggerSingle
} from "actions/bike-scan-trigger/actions";

class CreateModal extends Component {
  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);

    this.state = {
      name: "",
      reason: "",
      userId: "",
      qr: "",
      description: "",
      actions: []
    };

    if (!this.props.actionsList.length) {
      this.props.triggerGetActions();
    }

    if (this.props.id) {
      this.props.triggerSingle(this.props.id);
    }

    this.validator = new SimpleReactValidator({
      locale: "en",
      element: message => <div className="text-danger">{message}</div>
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ...nextProps.single
    });
  }

  componentWillUnmount() {
    if (this.props.id) {
      this.props.triggerSingle(false);
    }
  }

  handleChange = ev => {
    this.setState({
      [ev.target.name]: ev.target.value
    });
  };

  handleSave = () => {
    if (this.validator.allValid()) {
      const data = Object.assign({}, this.state);
      if (!data.userId) {
        data.userId = null;
      }
      if (!data.qr) {
        data.qr = null;
      }
      if (this.props.id) {
        data.id = this.props.id;
        this.props.triggerUpdate(data.id, data, this.props.onCancel);
      } else {
        this.props.triggerAdd(data, this.props.onCancel);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { actionsList } = this.props;
    const {
      name,
      reason,
      userId,
      qr,
      description,
      actions
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={name}
                onChange={this.handleChange}
              />
              {this.validator.message("name", name, "required")}
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Reason</label>
              <input
                type="text"
                className="form-control"
                name="reason"
                value={reason}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Actions</label>
              <SearchSelect
                className="search-select"
                isLoading={false}
                onChange={options => {
                  this.setState({
                    actions: options
                      ? options.map(item => item.value)
                      : []
                  });
                }}
                options={actionsList.map(value => ({
                  label: value,
                  value
                }))}
                value={actions
                  ? actions.map(item => ({
                    label: item,
                    value: item
                  })) : null}
                isMulti={true}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-12 col-sm-5">
                <div className="form-group mb-0">
                  <label>UserId</label>
                  <input
                    type="text"
                    className="form-control"
                    name="userId"
                    value={userId}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="align-items-center col-12 col-sm-2 d-inline-flex justify-content-center text-center">
                <div className="mt-sm-3">OR</div>
              </div>
              <div className="col-12 col-sm-5">
                <div className="form-group mb-0">
                  <label>Bike QR</label>
                  <input
                    type="text"
                    className="form-control"
                    name="qr"
                    value={qr}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="col-12 mb-3">
                {this.validator.message("User id or Bike qr", userId || qr, "required")}
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Description</label>
              <textarea
                className="form-control"
                name="description"
                value={description}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-danger"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSave}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

CreateModal.propTypes = {
  id: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

const mapStateToProps = state => ({
  actionsList: state.bikeScanTrigger.actions,
  single: state.bikeScanTrigger.single
});

const mapStateToDispatch = dispatch => ({
  triggerAdd: bindActionCreators(triggerAdd, dispatch),
  triggerUpdate: bindActionCreators(triggerUpdate, dispatch),
  triggerGetActions: bindActionCreators(triggerGetActions, dispatch),
  triggerSingle: bindActionCreators(triggerSingle, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(CreateModal);



// WEBPACK FOOTER //
// ./src/views/pages/bikes-scan-trigger/create-modal.js